<div class="policy-content">
  <h1>Termos de Serviço</h1>
  <p class="last-update">Última atualização: {{ currentDate }}</p>

  <section class="policy-section">
    <h2>1. Aceitação dos Termos</h2>
    <p>
      Ao utilizar nossa plataforma, você concorda com estes Termos de Serviço e com nossa Política de Privacidade. Se não concordar, por favor, não
      utilize nossos serviços.
    </p>
  </section>

  <section class="policy-section">
    <h2>2. Descrição do Serviço</h2>
    <p>
      Somos uma plataforma digital que facilita o agendamento de consultas e exames médicos com diversas especialidades e estabelecimentos de saúde
      parceiros.
    </p>
  </section>

  <section class="policy-section">
    <h2>3. Cadastro e Conta</h2>
    <p>Para utilizar nossos serviços, você precisará:</p>
    <ul>
      <li>Fornecer informações precisas e atualizadas</li>
      <li>Manter a confidencialidade de suas credenciais</li>
      <li>Ser responsável por todas as atividades em sua conta</li>
      <li>Ter pelo menos 18 anos ou ter consentimento dos responsáveis</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>4. Agendamentos</h2>
    <p>Ao agendar consultas ou exames:</p>
    <ul>
      <li>Você concorda em comparecer no horário marcado</li>
      <li>Cancelamentos devem ser feitos com antecedência mínima de 24 horas</li>
      <li>Não nos responsabilizamos por atrasos ou cancelamentos dos profissionais</li>
      <li>Taxas podem ser aplicadas para não comparecimento sem aviso</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>5. Pagamentos</h2>
    <p>Para serviços premium ou agendamentos que requerem pagamento:</p>
    <ul>
      <li>Todos os valores serão claramente informados antes da confirmação</li>
      <li>Pagamentos são processados por gateways seguros</li>
      <li>Reembolsos seguem a política da clínica/profissional</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>6. Responsabilidades</h2>
    <p>Atuamos como intermediários no agendamento:</p>
    <ul>
      <li>Não fornecemos serviços médicos diretamente</li>
      <li>Não nos responsabilizamos pela qualidade do atendimento dos profissionais</li>
      <li>Recomendamos verificar as credenciais dos profissionais</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>7. Conduta do Usuário</h2>
    <p>Você concorda em não:</p>
    <ul>
      <li>Utilizar a plataforma para fins ilegais</li>
      <li>Agendar consultas falsas ou fraudulentas</li>
      <li>Prejudicar o funcionamento técnico da plataforma</li>
      <li>Violar direitos de propriedade intelectual</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>8. Modificações no Serviço</h2>
    <p>Reservamo-nos o direito de:</p>
    <ul>
      <li>Modificar ou descontinuar serviços temporária ou permanentemente</li>
      <li>Atualizar estes Termos periodicamente</li>
      <li>Encerrar contas que violarem estes Termos</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>9. Limitação de Responsabilidade</h2>
    <p>Não seremos responsáveis por:</p>
    <ul>
      <li>Danos indiretos, incidentais ou consequenciais</li>
      <li>Erros ou omissões nas informações dos profissionais</li>
      <li>Problemas técnicos além de nosso controle razoável</li>
    </ul>
  </section>

  <section class="policy-section">
    <h2>10. Disposições Gerais</h2>
    <p>Estes Termos são regidos pelas leis brasileiras. Eventuais disputas serão resolvidas no foro da comarca onde a empresa tem sede.</p>
  </section>

  <section class="policy-section">
    <h2>11. Contato</h2>
    <p>Para dúvidas sobre estes Termos:</p>
    <address>
      Email: contato@possoagendar.com<br />
      Telefone: (74) 3611-1424<br />
      Endereço: R. do Paraiso, 385 - Santo Antonio, Juazeiro - BA, 48903-050
    </address>
  </section>
</div>
